import { george, observer, React, RouteComponentProps } from "aaa";
import { PluginCode } from "types/plugins";
import { ProductThumbnailBig } from "./ProductThumbnailBig";
import { ProductThumbnailSmall } from "./ProductThumbnailSmall";
import { PLUGIN_IMAGES, PRODUCTS, StoreStore } from "./StoreStore";

type IProps = RouteComponentProps<{}> & {
    store: StoreStore
};

@observer
export class StoreImageTest extends React.Component<IProps, {}> {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        const { store } = this.props;

        const productImages = store.storeProducts.map(product => {
            return (
                <div key={product.channelProduct + product.productId}>
                    <ProductThumbnailBig item={product} width={400} />
                    <div style={{ height: 20 }} />
                    <ProductThumbnailSmall item={product} />
                    <div style={{ height: 20 }} />
                </div>
            );
        });

        const pluginImages = store.storePlugins.map(plugin => {
            return (
                <div key={plugin.productCode}>
                    <ProductThumbnailBig item={plugin} width={400} />
                    <div style={{ height: 20 }} />
                    <ProductThumbnailSmall item={plugin} />
                    <div style={{ height: 20 }} />
                </div>
            );
        });

        return (
            <george.Background>
                <div style={{ padding: 20 }}>
                    {productImages}
                    {pluginImages}
                </div>
            </george.Background >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/store/StoreImageTest.tsx